import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { 
    View,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable,
    JDDialog
} from '@jdreact/jdreact-core-lib';
import { get, post } from '../../common/fetch';
import { pt, px, tip, getLabel } from '../../common/utils';
import Stars from '../stars';
import sgmReport from '../../common/sgmUtil';

class OrderScore extends PureComponent{
    state = {rateScore: null}

    render() {
        const { dialogShow } = this.props;
        const { rateScore } = this.state;
        return (
            <JDDialog show={dialogShow} 
                      dialogStyle = {st.score_box} 
                      onClose={() => this._closeDialog('dialogShow')}
                      overlayClickable={false}>
                <View style={[st.score_dialog]}>
                    <View style={[st.text_center,st.t_box]}>
                        <JDText style={st.text_t}>我的评分</JDText>
                    </View>
                    <View style={[st.text_center,st.q_box]}>
                    {!!rateScore ?
                        <JDText style={st.popup_info_rate}>{Number(rateScore).toFixed(1)}
                            <JDText style={st.popup_info_rate_addition}>分 | {getLabel(rateScore)}</JDText>
                        </JDText> :
                        <JDText style={st.popup_info_sub}>期待您的评分</JDText>
                    }
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                        <Stars score={rateScore} size={40} onPress={this.rate} />
                    </View>
                    {/* <View style={[st.text_center,st.star_box]}>
                        {
                            stars.map((v,i)=>{
                                return (
                                    <JDTouchable key={i} onPress={()=>this.rate(i)}><JDImage style={st.star_item} source={img[v]}></JDImage></JDTouchable>
                                )
                            })
                        }
                    </View> */}
                    {/* <View style={[st.text_center,st.s_box]}>
                        <JDTouchable style={[st.text_center,st.submit_btn]} onPress={this.submit}><JDText style={st.text_submit}>提交</JDText></JDTouchable>
                    </View> */}
                    <JDTouchable style={st.popup_info_submit_wrap} onPress={this.submit}>
                        <JDText style={st.popup_info_submit}>提交</JDText>
                    </JDTouchable>
                </View>
                <View style={[st.close_box,st.text_center]}>
                    <JDTouchable onPress={() => this.setState({rateScore: null}, ()=>{
                        this._closeDialog('dialogShow')
                      })}>
                        <JDImage style={st.close_icon} source={img.close}></JDImage>
                    </JDTouchable>
                </View>
            </JDDialog>
        );
    }
    _closeDialog = () => {
        this.props.closeScoreDialog();
    }
    _closeChangeScore = (score) => {
        const { dispatch, starLevel } = this.props;
        if (score === starLevel) return;
        dispatch({
            type: 'starLevel_change',
            starLevel: score
        });
    }
    rate = (score) => {
        this.setState({
            rateScore: score
        });
    }
    /* 提交评分 */
    submit = () => {
        const { movieId, movieName } = this.props;
        const { rateScore: starLevel } = this.state;
        if (!starLevel) {
            tip('请进行评分！');
            return;
        }
        // operType movieName不需要了
        // flag 10
        post('userWannaSeeOrScore', { flag: 10, movieId, starLevel }, true).then((res) => {
            this.setState({
                rateScore: starLevel
            });
            this._closeChangeScore(starLevel);
            this.props.closeScoreDialog();
            tip('评分成功!');
        }, (err) => {
            console.log(err);
            tip('评分失败!');
        }).catch((err) => {
            console.log(err);
        });

        if(!movieId || !starLevel){
            sgmReport('1001', {function_id: 'userWannaSeeOrScore',message:'缺少参数movieId/starLevel'}, 3)
        }
    }
};
const img = {
    gray_star: require('./img/gray_star.png'),
    star: require('./img/star.png'),
    close: require('./img/close.png'),
};
const st = StyleSheet.create({
    text_center: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    score_box: {
        width: '94.4%',
        backgroundColor: 'transparent',
        borderWidth: 0
    },
    score_dialog: {
        backgroundColor: '#fff',
        borderRadius: pt(4),
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: pt(22)
    },
    t_box: {
        paddingTop: pt(22)
    },
    text_t: {
        color: '#252525',
        fontSize: pt(28)
    },
    q_box: {
        height: pt(40),
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: pt(20),
        marginTop: pt(10),
    },
    text_q: {
        color: '#666',
        fontSize: pt(14)
    },
    star_box: {
        flexDirection: 'row',
        paddingBottom: pt(19)
    },
    star_item: {
        marginLeft: pt(8),
        marginRight: pt(8),
        width: pt(40)
    },
    s_box: {
        paddingBottom: pt(22)
    },
    submit_btn: {
        borderWidth: px(1),
        borderColor: '#FF2000',
        height: pt(38),
        borderRadius: pt(20),
        width: '36.72%'
    },
    text_submit: {
        fontSize: pt(18),
        color: '#F0250F'
    },
    close_box: {
        backgroundColor: 'transparent',
        paddingTop: pt(12)
    },
    close_icon: {
        width: pt(27),
        height: pt(27)
    },
    popup_info_sub: {
        // marginTop: pt(9),
        // marginBottom: pt(24),
        color: '#666',
        fontSize: pt(14),
        lineHeight: pt(20),
        letterSpacing: pt(3),
    },
    popup_info_rate: {
        // marginTop: pt(9),
        // marginBottom: pt(19),
        color: '#FF7910',
        fontSize: pt(30),
    },
    popup_info_rate_addition: {
        color: '#252525',
        fontSize: pt(14),
    },
    popup_info_submit_wrap: {
        height: pt(38),
        width: pt(130),
        marginTop: pt(19),
        borderRadius: pt(19),
        borderWidth: pt(1),
        borderColor: '#F0250F',
        justifyContent: 'center',
        alignItems: 'center'
    },
    popup_info_submit: {
        // lineHeight: pt(38),
        // textAlign: 'center',
        color: '#F0250F',
        fontSize: pt(18),
    }
});

const score = state => {
    let { starLevel } = state.orderDetail;
    return { starLevel };
};


export default connect(score, null, null, { withRef: true })(OrderScore);